


























































































































import Vue from 'vue';
import { get } from 'lodash';
import { isSameDay } from 'date-fns';

import axios from 'axios';
import VueObserveVisibility from 'vue-observe-visibility';
import i18n from 'vue-i18n';
import EventBus from '@/eventBus';

import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoAlert from '@/components/Molecules/co-alert/CoAlert.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import CoUser from '@/components/Molecules/co-user/CoUser.vue';
import CoMessage from '@/components/Molecules/co-message/CoMessage.vue';
import CoDate from '@/components/Molecules/co-date/CoDate.vue';

type ChatScrollAnchor = {
    chat: HTMLElement;
    scrollTop: number;
    messageID?: string;
    offset?: number;
};

Vue.use(VueObserveVisibility);

export default {
    i18n: {
        messages: {
            en: {
                hasnotificationsoff: '{username} has notifications turned off',
                senderror: 'Sending failed! Please try again',
                sending: 'sending ...',
                sent: 'sent',
            },
            de: {
                hasnotificationsoff: '{username} hat Benachrichtigungen deaktiviert',
                senderror: 'Senden fehlgeschlagen! Bitte versuche es erneut',
                sending: 'senden ...',
                sent: 'gesendet',
            },
        },
    },
    name: 'ChatThread',
    components: {
        CoRoundButton,
        CoAlert,
        CoText,
        CoLink,
        CoUser,
        CoMessage,
        CoDate,
    },
    data() {
        return {
            messagesLoading: false,
            notificationsPaused: false,
            threadID: this.$route.params.slug,
            thread: null,
            participants: {},
            currentThreadUsers: [],
            chatRenderKey: 1,
            currentThreadMessages: [],
            inputText: '',
            meID: this.$store?.state?.me?.ID,
            sending: false,
            realtimeRecoveryThreadID: null,
        };
    },
    computed: {
        user() {
            return this.$store.state.me;
        },
    },
    watch: {
        $route(to, from) {
            const lastThreadID = from.params.slug;
            EventBus.$off(`MESSAGE_${lastThreadID}`);

            this.threadID = to.params.slug;

            EventBus.$on(
                `MESSAGE_${this.threadID}`,
                (payLoad) => {
                    this.onMessage(payLoad);
                },
                this
            );

            this.getThreadByID(this.threadID);
        },
    },

    mounted() {
        this.getThreadByID(this.threadID);

        EventBus.$on(
            `MESSAGE_${this.threadID}`,
            (payLoad) => {
                this.onMessage(payLoad);
            },
            this
        );

        EventBus.$on(
            'THREAD_UPDATED',
            (payLoad) => {
                this.getThreadByID(this.threadID);
            },
            this
        );
        EventBus.$on('REALTIME_STREAM_RECONNECTED', this.recoverMessagesAfterRealtimeReconnect, this);
    },
    beforeDestroy() {
        EventBus.$off(`MESSAGE_${this.threadID}`);
        EventBus.$off('THREAD_UPDATED');
        EventBus.$off('REALTIME_STREAM_RECONNECTED', this.recoverMessagesAfterRealtimeReconnect);
    },
    methods: {
        get,
        isSameDay,
        checkIfNotificationsPaused(peer) {
            if (!this.thread.GroupChat && this.thread.Peer) {
                let now = new Date().getTime();
                now /= 1000;
                if (now < this.thread.Peer.NotificationsOffUntill) {
                    this.notificationsPaused = true;
                    if (this.thread.Peer.NotificationsOffMessage) {
                        const msg = [
                            {
                                ID: Math.random(),
                                Timestamp: now,
                                Text: `<p><small>${this.$t('labels.awaynotice')}</small></p>${
                                    this.thread.Peer.NotificationsOffMessage
                                }`,
                                From: this.thread.Peer.ID,
                                To: this.meID,
                            },
                        ];

                        this.currentThreadMessages.unshift(...msg);
                    }
                } else {
                    this.notificationsPaused = false;
                }
            }
        },
        markAsSeen(visablity, entry, id, own, status) {
            if (!visablity || own || status === 'seen') {
                return;
            }
            const ids = JSON.stringify({
                IDs: [id],
            });
            axios({
                method: 'POST',
                url: '/chat/msgs/seen',
                withCredentials: true,
                data: ids,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.$store.commit('DECREMENT_UNSEEN_MESSAGES', this.threadID);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        back() {
            this.$router.push('/messenger');
        },
        onMessage(msg) {
            // to do check if msg has correct format
            const messageObject = {
                ID: msg.id,
                Timestamp: msg.timestamp,
                Text: msg.text,
                From: msg.from,
                To: msg.to,
            };
            this.currentThreadMessages.unshift(messageObject);
            // scroll to bottom
            setTimeout(() => {
                document.querySelector('#start-of-thread-scroll-marker')?.scrollIntoView(false);
            }, 1);
        },
        captureChatScrollAnchor() {
            const chat = this.$refs.chat as HTMLElement | undefined;
            if (!chat) return null;

            const chatBounds = chat.getBoundingClientRect();
            const anchor = Array.from(chat.querySelectorAll<HTMLElement>('.message')).find((message) => {
                const bounds = message.getBoundingClientRect();
                return bounds.bottom > chatBounds.top && bounds.top < chatBounds.bottom;
            });
            if (!anchor) return { chat, scrollTop: chat.scrollTop };

            return {
                chat,
                scrollTop: chat.scrollTop,
                messageID: anchor.dataset.messageId,
                offset: anchor.getBoundingClientRect().top - chatBounds.top,
            };
        },
        restoreChatScrollAnchor(anchor: ChatScrollAnchor | null) {
            if (!anchor) return;
            const { chat: chatElement, messageID, offset, scrollTop } = anchor;
            if (!messageID) {
                chatElement.scrollTop = scrollTop;
                return;
            }

            const message = Array.from(chatElement.querySelectorAll<HTMLElement>('.message')).find(
                (entry) => entry.dataset.messageId === messageID
            );
            if (!message) {
                chatElement.scrollTop = scrollTop;
                return;
            }

            chatElement.scrollTop +=
                message.getBoundingClientRect().top - chatElement.getBoundingClientRect().top - (offset || 0);
        },
        async recoverMessagesAfterRealtimeReconnect() {
            const { threadID } = this;
            if (!threadID || this.realtimeRecoveryThreadID === threadID) return;

            this.realtimeRecoveryThreadID = threadID;
            try {
                const response = await axios.get(`/chat/msgs/list/${threadID}`);
                if (threadID !== this.threadID) return;

                const recoveredMessages = response.data?.messages || [];
                const loadedMessageIDs = new Set(this.currentThreadMessages.map((message) => message.ID));
                const missingMessages = recoveredMessages.filter((message) => !loadedMessageIDs.has(message.ID));
                if (missingMessages.length === 0) return;

                // Reconnect recovery adds only unseen messages and keeps the reader's visible message anchored.
                const scrollAnchor = this.captureChatScrollAnchor();
                this.currentThreadMessages = [...missingMessages, ...this.currentThreadMessages];
                missingMessages.forEach((message) => {
                    if (!this.participants[message.From]) this.getAuthor(message.From);
                });
                await this.$nextTick();
                this.restoreChatScrollAnchor(scrollAnchor);
            } catch (error) {
                console.log('Failed to recover missed chat messages after realtime reconnect', error);
            } finally {
                if (this.realtimeRecoveryThreadID === threadID) this.realtimeRecoveryThreadID = null;
            }
        },
        async sendMessage() {
            if (this.inputText === '<p></p>') return;

            const newMessage = {
                From: this.meID,
                ThreadID: this.threadID,
                Text: this.inputText,
                SpaceID: this.$store?.state?.space?.ID,
            };

            // send message
            try {
                this.sending = true;
                const sentMessage = await axios.post('/chat/msgs/send', newMessage);

                // append message to current messages
                // and clear editor
                this.currentThreadMessages.unshift(sentMessage.data);
                EventBus.$emit('THREAD_ACTIVITY', {
                    ThreadID: this.threadID,
                });
                this.$refs.editor.clear(true, true);
                this.$refs.editor.focus();
                setTimeout(() => {
                    document.querySelector('#start-of-thread-scroll-marker')?.scrollIntoView(false);
                }, 1);
            } catch (error) {
                console.log('Error sending message', error);
                EventBus.$emit('ERROR', {
                    Message: this.$t('senderror'),
                });
            } finally {
                this.sending = false;
            }
        },
        loadMessages(url = `/chat/msgs/list/${this.threadID}`) {
            this.messagesLoading = true;
            axios
                .get(url)
                .then(async (response) => {
                    const messages = response.data?.messages || [];
                    if (messages.length === 0) {
                        this.messagesLoading = false;
                        return;
                    }
                    const sendersleftIDs = messages
                        .map((msg) => {
                            // if sender of the message is no longer in participants, fetch user data separately
                            if (this.participants[msg.From]) return false;
                            return {
                                ID: msg.From,
                            };
                        })
                        .filter(Boolean);
                    try {
                        const { Users } = await this.$store.dispatch('listUsersByIDs', {
                            ids: { IDS: sendersleftIDs },
                        });
                        const [user] = Users;
                        Users.map((u) => {
                            this.participants[u.ID] = {
                                ...u,
                                HasLeft: true,
                            };
                        });
                    } catch (error) {
                        console.log('Error fetching user data', error);
                    }

                    this.currentThreadMessages.push(...messages);
                    if (response?.data?.next && response.data.next !== '') {
                        this.loadMessages(response.data.next);
                    } else {
                        // all messages loaded:
                        // show thread and scroll to bottom
                        this.messagesLoading = false;
                        setTimeout(() => {
                            document.querySelector('#start-of-thread-scroll-marker')?.scrollIntoView(false);
                        }, 1);
                    }
                    this.$refs.editor.focus();
                })
                .catch((error) => {
                    console.log(error);
                    this.messagesLoading = false;
                });
        },
        getAuthor(id) {
            const ids = JSON.stringify({ IDS: [{ ID: id }] });
            this.$store
                .dispatch('listUsersByIDs', { ids })
                .then((response) => {
                    if (response.Users != null) {
                        this.participants[id] = response.Users[0];
                    } else {
                        this.participants[id] = {
                            ID: id,
                            Profile: { ImageURL: '', Name: 'User not found' },
                        };
                    }
                })
                .catch((error) => {
                    this.participants[id] = {
                        ID: id,
                        Profile: { ImageURL: '', Name: 'User not found' },
                    };
                    console.log(error);
                    // todo show error
                });
        },
        getThreadByID(id) {
            axios
                .get(`/chat/t/by-id/${id}`)
                .then((response) => {
                    this.thread = response.data;

                    this.currentThreadMessages = [];
                    this.checkIfNotificationsPaused();
                    this.thread.Peers.forEach((element) => {
                        this.participants[element.ID] = element;
                    });
                    this.participants[this.$store.state.me.ID] = this.$store.state.me;
                    this.loadMessages();
                })
                .catch((error) => {
                    this.messagesLoading = false;
                    console.log(error);
                });
        },
    },
};
